
import homeAnim from "./home";
import gammesAnim from "./gammes";
import aboutAnim from "./about";
import atelierAnim from "./atelier";
import gammeAnim from "./gamme";
import contactAnim from "./contact";

let homepage = document.querySelector("#home");
if (homepage !== null) {
  homeAnim.init();
}

let gammespage = document.querySelector("#gammes-page");
if (gammespage !== null) {
  gammesAnim.init();
}

let gammepage = document.querySelector("#gamme-page");
if (gammepage !== null) {
  gammeAnim.init();
}

let aboutpage = document.querySelector("#about-page");
if (aboutpage !== null) {
  aboutAnim.init();
}

let atelierpage = document.querySelector("#savoir-faire-page");
if (atelierpage !== null) {
  atelierAnim.init();
}


let contactpage = document.querySelector("#contact-page");
if (contactpage !== null) {
  contactAnim.init();
}




const menuToggle = document.querySelector(".menu-toggle");
      const navigation = document.querySelector(".site-navigation");
      const siteHeader = document.querySelector(".site-header");

      if (siteHeader) {
        const updateHeaderState = () => {
          siteHeader.classList.toggle("is-scrolled", window.scrollY > 40);
        };

        updateHeaderState();
        window.addEventListener("scroll", updateHeaderState, { passive: true });
      }

      if (menuToggle && navigation) {
        menuToggle.addEventListener("click", () => {
          const isOpen = menuToggle.getAttribute("aria-expanded") === "true";
          menuToggle.setAttribute("aria-expanded", String(!isOpen));
          navigation.classList.toggle("is-open", !isOpen);
        });
      }

const siteFooter = document.querySelector(".site-footer");
if (siteFooter && window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
  siteFooter.addEventListener("pointerenter", () => {
    siteFooter.classList.add("is-cursor-inside");
  });

  siteFooter.addEventListener("pointermove", (event) => {
    const bounds = siteFooter.getBoundingClientRect();
    gsap.to(siteFooter, {
      "--cursor-x": `${event.clientX - bounds.left}px`,
      "--cursor-y": `${event.clientY - bounds.top}px`,
      duration: 0.75,
      ease: "power2.out",
      overwrite: "auto",
    });
  });

  siteFooter.addEventListener("pointerleave", () => {
    siteFooter.classList.remove("is-cursor-inside");
  });
}

const lightboxTriggers = Array.from(document.querySelectorAll(".product-lightbox-trigger"));
const lightbox = document.querySelector(".product-lightbox");

if (lightboxTriggers.length && lightbox) {
  const lightboxImage = lightbox.querySelector(".product-lightbox__image");
  const lightboxCounter = lightbox.querySelector(".product-lightbox__counter");
  const closeButton = lightbox.querySelector(".product-lightbox__close");
  const previousButton = lightbox.querySelector(".product-lightbox__previous");
  const nextButton = lightbox.querySelector(".product-lightbox__next");
  let activeIndex = 0;

  const showImage = (index) => {
    activeIndex = (index + lightboxTriggers.length) % lightboxTriggers.length;
    const trigger = lightboxTriggers[activeIndex];
    lightboxImage.src = trigger.dataset.lightboxSrc;
    lightboxImage.alt = trigger.dataset.lightboxAlt || "";
    lightboxCounter.textContent = `${activeIndex + 1} / ${lightboxTriggers.length}`;
  };

  const closeLightbox = () => {
    lightbox.classList.remove("is-open");
    lightbox.setAttribute("aria-hidden", "true");
    document.body.classList.remove("lightbox-is-open");
  };

  lightboxTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      showImage(Number(trigger.dataset.lightboxIndex));
      lightbox.classList.add("is-open");
      lightbox.setAttribute("aria-hidden", "false");
      document.body.classList.add("lightbox-is-open");
      closeButton.focus();
    });
  });

  closeButton.addEventListener("click", closeLightbox);
  previousButton.addEventListener("click", () => showImage(activeIndex - 1));
  nextButton.addEventListener("click", () => showImage(activeIndex + 1));

  lightbox.addEventListener("click", (event) => {
    if (event.target === lightbox) closeLightbox();
  });

  document.addEventListener("keydown", (event) => {
    if (!lightbox.classList.contains("is-open")) return;
    if (event.key === "Escape") closeLightbox();
    if (event.key === "ArrowLeft") showImage(activeIndex - 1);
    if (event.key === "ArrowRight") showImage(activeIndex + 1);
  });
}

/* SWIPER CODE */
/* const swiper = new Swiper(".projectSwiper", {
          slidesPerView: 1,
          init: false,
          spaceBetween: 0,
          loop: true,
          keyboard: {
            enabled: true,
            onlyInViewport: false,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        }); */



